import { ImportActionType } from "../const/import-action-type";
import { ImportFieldType } from "../const/field-type";
import { SubscriptionSource } from "../const/subscription-source";

export const importGetters = {
  isActionMissing: (state) => state.actionType === ImportActionType.None,
  isFileMissing: (state) => state.fileToUpload == null,
  mappedFields: (state) => state.fieldMappings.selectedFields,
  treatNegativeStatusAsUnknown: (state) => state.treatNegativeStatusAsUnknown,
  isColumnSelected: (state) => (index) => state.fieldMappings.selectedFields[index] !== ImportFieldType.IGNORE,
  isMappingPreviewLoading: (state) => state.fieldMappings.isPreviewLoading,
  unmappedFields: (state) => {
    const mappings = state.fieldMappings;
    const source = state.subscriptions.source;
    switch (state.actionType) {
      case ImportActionType.UpdateEmailSubscribersStatus:
        return mappings.emailSubscribeFields
          .filter((field) => {
            return !(source === SubscriptionSource.Manual && field === ImportFieldType.EMAIL_SUBSCRIPTION_STATUS);
          })
          .map((field) => ({
            id: field,
            label: `import.mappings.fields.${field}`,
            hidden: field !== ImportFieldType.IGNORE && mappings.selectedFields.includes(field),
          }));
      case ImportActionType.UpdateSMSSubscribersStatus:
        return mappings.smsSubscribeFields
          .filter((field) => {
            return !(source === SubscriptionSource.Manual && field === ImportFieldType.SMS_SUBSCRIPTION_STATUS);
          })
          .map((field) => ({
            id: field,
            label: `import.mappings.fields.${field}`,
            hidden: field !== ImportFieldType.IGNORE && mappings.selectedFields.includes(field),
          }));
      case ImportActionType.AddUpdateTags:
        return mappings.tagsFields.map((field) => ({
          id: field,
          label: `import.mappings.fields.${field}`,
          hidden: field !== ImportFieldType.IGNORE && mappings.selectedFields.includes(field),
        }));
      default:
        return mappings.availableFields
          .filter((field) => {
            return !(source === SubscriptionSource.Manual && field === ImportFieldType.EMAIL_SUBSCRIPTION_STATUS);
          })
          .filter((field) => {
            return !(source === SubscriptionSource.Manual && field === ImportFieldType.SMS_SUBSCRIPTION_STATUS);
          })
          .filter((field) => {
            return !(source === SubscriptionSource.Manual && field === ImportFieldType.WHATSAPP_SUBSCRIPTION_STATUS);
          })
          .filter((field) => {
            return !(source === SubscriptionSource.NoUpdate && field === ImportFieldType.EMAIL_SUBSCRIPTION_STATUS);
          })
          .filter((field) => {
            return !(source === SubscriptionSource.NoUpdate && field === ImportFieldType.SMS_SUBSCRIPTION_STATUS);
          })
          .filter((field) => {
            return !(source === SubscriptionSource.NoUpdate && field === ImportFieldType.WHATSAPP_SUBSCRIPTION_STATUS);
          })
          .map((field) => ({
            id: field,
            label: `import.mappings.fields.${field}`,
            hidden: field !== ImportFieldType.IGNORE && mappings.selectedFields.includes(field),
          }));
    }
  },
  fileName: (state) => {
    return state.fileToUpload ? state.fileToUpload.name : "";
  },
  fileSize: (state) => {
    return state.fileToUpload ? state.fileToUpload.size : "";
  },
  previewRows: (state) => {
    return state.skipFirstLine ? state.fieldMappings.previewRows.slice(1) : state.fieldMappings.previewRows;
  },
  tags: (state) => state.tags.importTags,
  newTagName: (state) => state.tags.newTagName,
  subscriptionSource: (state) => state.subscriptions.source,
  resurrectDeletedCustomer: (state) => state.resurrectCustomer,
  subscriptionStatusEmail: (state) => state.subscriptions.email,
  subscriptionStatusSms: (state) => state.subscriptions.sms,
  subscriptionStatusWhatsapp: (state) => state.subscriptions.whatsapp,
  importHistory: (state) => state.importHistory,
  tagsAction: (state) => state.tags.action,
  mappingErrors: (state) => {
    const fields = state.fieldMappings.selectedFields;
    return {
      emailOrPhone: !fields.includes(ImportFieldType.EMAIL) && !fields.includes(ImportFieldType.PHONE),
      subscription:
        state.subscriptions.source === SubscriptionSource.File &&
        !fields.includes(ImportFieldType.SMS_SUBSCRIPTION_STATUS) &&
        !fields.includes(ImportFieldType.EMAIL_SUBSCRIPTION_STATUS) &&
        !fields.includes(ImportFieldType.WHATSAPP_SUBSCRIPTION_STATUS),
    };
  },
  hasMappingErrors: (state, getters) => Object.values(getters.mappingErrors).some((e) => Boolean(e)),
  isActionSelected: (state) => {
    if (
      state.subscriptions.source === SubscriptionSource.Manual &&
      (state.subscriptions.email === null || state.subscriptions.sms === null)
    ) {
      return false;
    }
    return true;
  },
  wizardLinks: (state, getters) => {
    const hasFile = state.fileToUpload != null;
    const hasMapping = !getters.hasMappingErrors;
    return [
      {
        pathPattern: /\/app\/import\/v2\/(actions|duplicates)/,
        href: "/app/import/v2/actions",
      },
      {
        pathPattern: /\/app\/import\/v2\/upload/,
        href: getters.isActionSelected ? "/app/import/v2/upload" : "",
      },
      {
        pathPattern: /\/app\/import\/v2\/mapping/,
        href: getters.isActionSelected && hasFile ? "/app/import/v2/mapping" : "",
      },
      {
        pathPattern: /\/app\/import\/v2\/tags/,
        href: getters.isActionSelected && hasFile && hasMapping ? "/app/import/v2/tags" : "",
      },
      {
        pathPattern: /\/app\/import\/v2\/summary/,
        href: getters.isActionSelected && hasFile && hasMapping ? "/app/import/v2/summary" : "",
      },
    ];
  },
  checksum: (state) => state.checksum,
};
